import axios from "axios"
import { removeEmptyAttributes } from "../helpers/objects"

const locationTypes = ["countries", "locations"]
const path = "/fam/targeting/search"

const mapTargetingToReachEstimateRequest = requestData => {
  requestData = removeEmptyAttributes(requestData)

  if (requestData.interestsGroups && requestData.interestsGroups.length > 0) {
    requestData.interestsGroups = requestData.interestsGroups.map(group => {
      return {
        items: group.items.map(mapInterestToRequest),
      }
    })
  }

  if (
    requestData.excludedInterests &&
    requestData.excludedInterests.length > 0
  ) {
    requestData.excludedInterests = requestData.excludedInterests.map(
      mapInterestToRequest
    )
  }

  if (requestData.geoLocations && requestData.geoLocations.length > 0) {
    requestData.geoLocations = mapLocationToReachEstimateRequest(
      requestData.geoLocations
    )
  }

  if (
    requestData.excludedGeoLocations &&
    requestData.excludedGeoLocations.length > 0
  ) {
    requestData.excludedGeoLocations = mapLocationToReachEstimateRequest(
      requestData.excludedGeoLocations
    )
  }

  return requestData
}

const mapInterestToRequest = interest => ({
  id: interest.id,
  type: interest.type,
})

const mapLocationToReachEstimateRequest = locations => {
  return locations.map(location => {
    const locationData = {
      key: location.key,
      type: location.type,
    }

    if (location.radius) {
      locationData.radius = location.radius
    }

    return locationData
  })
}

export default {
  searchGeoLocations(query, locationType = "locations") {
    if (locationTypes.indexOf(locationType) < 0) {
      locationType = "locations"
    }

    const url = `${path}/${locationType}`

    const params = {
      q: query,
    }

    return axios.get(url, { params }).then(response => {
      return response.data
    })
  },

  searchInterests(adAccountId, query) {
    const url = `${path}/profile-specs`

    const params = {
      adAccountId,
      q: query,
    }

    return axios.get(url, { params }).then(response => {
      return response.data
    })
  },

  searchInterestsSuggestions(adAccountId, interests) {
    const url = `${path}/profile-specs/suggestions`

    const params = {
      adAccountId,
      targeting: interests.map(mapInterestToRequest),
    }

    return axios.post(url, params).then(response => {
      return response.data
    })
  },

  loadEstimatedReach(adAccountId, targeting) {
    const url = `/fam/${adAccountId}/targeting/reach-estimate`

    const requestData = mapTargetingToReachEstimateRequest(targeting)

    return axios
      .get(url, { params: { targeting: JSON.stringify(requestData) } })
      .then(response => {
        return response.data
      })
  },
}
